import React, { useEffect, useRef, useState } from "react";
import "./switch.css";
import { tokenDecode } from "../../utils/helper";
import { toast } from "react-toastify";
import Circularprogress from "../../components/Generics/Circularprogress";
import axios from "axios";
import { Link } from "react-router-dom";
import { config } from "../../utils/config";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import "../../index.css";
import ThemeMaker from "../../components/thememaker";
import CloseIcon from "@mui/icons-material/Close";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import QRCode from "react-qr-code";
import { toPng } from "html-to-image";
import DownloadForOfflineRoundedIcon from "@mui/icons-material/DownloadForOfflineRounded";
import { Modal as AntModal } from "antd";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Dropdown } from "antd";
import { S } from "./Css";
import "../../components/mcrbTableTheme.css";
const { apiEndpoint, baseNodeapiUrl } = config;

/* ─── MUI Modal base ─── */
const muiModalBase = {
  position: "absolute", top: "50%", left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper", boxShadow: 24,
  borderRadius: "16px", outline: "none",
};
const syncModalSx = { ...muiModalBase, width: 440, p: 3 };
const deleteModalSx = { ...muiModalBase, width: 440, p: 3 };
const qrModalSx = { ...muiModalBase, width: 320, p: 3 };

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

/* ─── Shopify SVG icon ─── */
const ShopifyIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="#96bf48" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.337 23.979l7.216-1.561s-2.604-17.613-2.621-17.73c-.017-.113-.114-.196-.228-.196-.114 0-2.099-.041-2.099-.041s-1.4-1.358-1.562-1.519c-.049-.048-.114-.073-.181-.081L15.337 23.979zM13.637 3.568c-.009 0-.019.001-.028.002-.267-.713-.74-1.369-1.568-1.369-.023 0-.047.001-.07.003C11.697 1.555 11.2 1.27 10.77 1.27c-3.471 0-5.143 4.34-5.661 6.545l-2.441.755C1.995 8.9 1.966 8.929 1.937 9.2L0 23.5l14.972 2.5L15.337 23.979 13.637 3.568zM11.293 4.11l-1.939.601c.529-2.036 1.535-3.021 2.42-3.397-.183.721-.415 1.67-.481 2.796zM10.77 1.74c.145 0 .29.046.432.134-.848.398-1.757 1.406-2.14 3.414l-1.617.5C7.993 3.933 9.208 1.74 10.77 1.74zM10.308 12.109c.059.974 2.622 1.186 2.771 3.473.116 1.797-.953 3.026-2.489 3.12-1.852.114-2.872-.977-2.872-.977l.393-1.668s1.026.775 1.847.722c.534-.033.728-.469.707-.77-.077-1.271-2.164-1.196-2.302-3.291-.115-1.76 1.046-3.545 3.601-3.701.984-.061 1.487.188 1.487.188l-.578 2.177s-.652-.3-1.424-.252c-1.13.07-1.144.793-1.141.979z" />
  </svg>
);

/* ═══════════════════════════════════
   MAIN COMPONENT
═══════════════════════════════════ */
const Instorecatalog = () => {
  const decoded = tokenDecode();
  const current_sellerid = decoded.data.user.seller_id;
  const { permission: { product } } = decoded?.data;

  /* ── State ── */
  const [searchValue, setsearchValue] = useState("");
  const [productlist, setproductlist] = useState([]);
  const [productisLoading, setproductisLoading] = useState(false);
  const [noproducts, setNoproducts] = useState(false);
  const [file, setFile] = useState(null);
  const [open, setOpen] = useState(false);
  const [Alertopen, setAlertOpen] = useState(false);
  const [syncing, setsyncing] = useState(false);
  const [ConfirmDeleteModalOpen, setConfirmDeleteModalOpen] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [selectedBox, setselectedBox] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemCheckboxes, setItemCheckboxes] = useState({});
  const [currentItems, setcurrentItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalvisible, setModalvisible] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [formodal, setformodal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [updateType, setUpdateType] = useState(null);
  const [expandedRows, setExpandedRows] = useState({});
  const [QRModalOpen, setQRModalOpen] = useState({ openstatus: false, value: "", isLoading: false });

  const fileInputRef = useRef(null);
  const qrRef = useRef(null);
  let rawToken = sessionStorage.getItem("us_st_d");

  const [syncingData, setsyncingData] = useState({
    seller_id: current_sellerid.toString(),
    price: false, inventory: false, sku: false, title: false, weight: false,
  });

  const defaultSyncingData = {
    seller_id: current_sellerid.toString(),
    price: false, inventory: false, sku: false, title: false, weight: false,
  };

  const [selectedFields, setSelectedFields] = useState({
    name: false, mrp: false, selling_price: false, short_description: false,
    description: false, quantity: false, image: false, tax_included_price: false, reference_id: false,
  });

  /* ── Pagination ── */
  const PAGE_SIZE = 100;
  const endOffset = itemOffset + PAGE_SIZE;
  const pageCount = Math.ceil(productlist.length / PAGE_SIZE);

  useEffect(() => {
    setcurrentItems([...productlist.slice(itemOffset, endOffset)]);
  }, [productlist, itemOffset]);

  useEffect(() => {
    const checkboxes = {};
    productlist.forEach(item => { checkboxes[item.id] = item.status; });
    setItemCheckboxes(checkboxes);
  }, [productlist]);

  useEffect(() => { getproductlist(); }, []);

  /* ── API helpers ── */
  async function getproductlist() {
    const parentId = decoded?.data?.user?.parent_id;
    const SellerId = decoded?.data?.user?.seller_id;
    const payload = parentId > 1 ? { seller_id: parentId } : { seller_id: SellerId };
    setproductisLoading(true);
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/get-product-list`, method: "GET",
        headers: { "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}` },
        data: payload,
      });
      if (data.status === 200) {
        setproductisLoading(false);
        setItemOffset(0);
        setproductlist(data.data);
      }
    } catch (error) { console.log(error); }
  }

  const Syncapi = async () => {
    const token = localStorage.getItem("token");
    try {
      await axios.post(`${apiEndpoint}/add-shopify-product`, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) { console.error("Sync failed", error); }
  };

  async function syncPriceHandler() {
    setsyncing(true);
    try {
      const data = await axios({
        url: `${baseNodeapiUrl}/shopify/sync`, method: "PUT",
        headers: { "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}` },
        data: {
          seller_id: syncingData.seller_id,
          price: syncingData.price.toString(), inventory: syncingData.inventory.toString(),
          sku: syncingData.sku.toString(), title: syncingData.title.toString(),
          weight: syncingData.weight.toString(),
        },
      });
      if (data.status === 200 && data.data.status === 200) {
        toast.success("Product synced successfully");
        setAlertOpen(false); setsyncing(false);
        getproductlist(); setsyncingData(defaultSyncingData);
      } else { toast.error("Something went wrong"); setsyncing(false); }
    } catch { setsyncing(false); }
  }

  async function deleteProductHandler(item) {
    try {
      const data = await axios({
        url: `${apiEndpoint}/deleteVarNonPro`, method: "POST",
        headers: { "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}` },
        data: { id: item.id, has_variations: item.has_variations },
      });
      if (data.status === 200) {
        toast.success("Product deleted successfully");
        getproductlist(); handleShipementModalClose();
      } else { toast.error("Something went wrong"); }
    } catch { toast.error("Something went wrong"); }
  }

  async function bulkdeleteHandler() {
    try {
      const data = await axios({
        url: `${apiEndpoint}/bulk_delete`, method: "POST",
        headers: { "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}` },
        data: selectedBox,
      });
      if (data.status === 200) {
        toast.success("Selected products deleted!"); getproductlist(); handleShipementModalClose();
      } else { toast.error("Something went wrong"); }
    } catch { toast.error("Something went wrong"); }
  }

  const exportToExcel = async () => {
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/allproductexport`, method: "POST",
        headers: { "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}` },
      });
      const headers = Object.keys(data.message[0]);
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(data.message, { header: headers });
      XLSX.utils.book_append_sheet(wb, ws, "Orders");
      XLSX.writeFile(wb, "seller_instoreProducts.xlsx");
      toast.success("Products exported successfully");
    } catch { toast.error("Server error, please try later!"); }
  };

  const exportToExcelDatas = async () => {
    setIsLoading(true);
    try {
      const response = await axios({
        url: `${apiEndpoint}/products/export`, method: "GET", responseType: "blob",
        headers: { "Content-Type": "application/json", "X-Custom-Authorization": `Bearer ${rawToken}` },
      });
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url; link.setAttribute("download", "products.xlsx");
      document.body.appendChild(link); link.click(); link.remove();
    } catch (error) { console.log("Error ===>", error); }
    finally { setIsLoading(false); }
  };

  const handleImport = async () => {
    Papa.parse(file, {
      header: true, dynamicTyping: true,
      complete: ({ data }) => {
        const x = data.map(item => ({
          reference_id: item.reference_id, position: item?.position,
          selling_price: item?.selling_price,
        }));
        sendDataToDb(x);
      },
    });
  };

  async function sendDataToDb(jsonData) {
    try {
      await axios({
        url: `${apiEndpoint}/updateprice`, method: "POST",
        headers: { "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}` },
        data: jsonData,
      });
      getproductlist();
    } catch { toast.error("403 error!"); }
  }

  async function getQRHandler(item) {
    const ProviderId = decoded?.data?.seller_data?.provider_id;
    setQRModalOpen({ ...QRModalOpen, openstatus: true, isLoading: true });
    try {
      const data = await axios({
        url: `${baseNodeapiUrl}/api/product_qr_Code`, method: "POST",
        headers: { "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}` },
        data: { id: ProviderId, descriptor_name: item?.name, location_id: ProviderId, bppId: "prod-sellerapp.shiprocket.com" },
      });
      setQRModalOpen({ openstatus: true, value: data.data.data, isLoading: false });
    } catch {
      setQRModalOpen({ ...QRModalOpen, openstatus: false, isLoading: false });
      toast.error("Error getting QR, please try later!");
    }
  }

  const handleDownload = () => {
    if (qrRef.current) {
      toPng(qrRef.current)
        .then(dataUrl => {
          const link = document.createElement("a");
          link.href = dataUrl; link.download = "qr-code.png";
          document.body.appendChild(link); link.click(); document.body.removeChild(link);
        })
        .catch(console.error);
    }
  };

  const handleSubmit = async () => {
    if (!selectedFile) { toast.error("No file selected!"); return; }
    const formData = new FormData();
    formData.append("file", selectedFile);
    try {
      await axios.post(`${apiEndpoint}/import-order-status`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
      });
      toast.success("File uploaded successfully!");
      setSelectedFile(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
      setModalvisible(false);
    } catch { toast.error("Failed to upload file."); }
  };

  const handlebuttonapi = async () => {
    try {
      await axios.post(
        `${apiEndpoint}/add-shopify-var-product`, { ondc: true },
        { headers: { "Content-Type": "application/json", "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}` } }
      );
      toast.success("Product inserted successfully");
    } catch (error) { console.error(error); }
  };

  const sendUpdate = async () => {
    if (updateType === "single" && !selectedProduct) { toast.error("No product selected"); return; }
    const selectedAttributes = Object.keys(selectedFields).filter(k => selectedFields[k]);
    if (selectedAttributes.length === 0) { toast.error("Select at least one field"); return; }
    const attributes_to_be_update = selectedAttributes.filter(a => a !== "reference_id");
    const product_id = updateType === "single" ? [selectedProduct.reference_id] : [];
    try {
      await axios.post(`${apiEndpoint}/update-product`, { product_id, attributes_to_be_update }, {
        headers: { "Content-Type": "application/json", "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}` },
      });
      toast.success("Product updated successfully!");
      setformodal(false);
    } catch { toast.error("Failed to update product"); }
  };

  /* ── Small handlers ── */
  const handleAlertOpen = () => { setOpen(false); setAlertOpen(true); };
  const handleAlertClose = () => { setAlertOpen(false); setsyncingData(defaultSyncingData); };
  const handleSyncModalClose = () => { setOpen(false); setsyncingData(defaultSyncingData); };
  const handleShipementModalClose = () => { setConfirmDeleteModalOpen(false); setProductToDelete(null); };
  const handleQRModalClose = () => setQRModalOpen({ ...QRModalOpen, openstatus: false });

  function syncCheckHandler(e) {
    const { name } = e.target;
    setsyncingData(prev => ({ ...prev, [name]: !prev[name] }));
  }

  function searchHandler(e) {
    setsearchValue(e.target.value);
    if (e.target.value === "") { getproductlist(); setNoproducts(false); }
  }

  async function searchResult(e) {
    if (e.key === "Enter") {
      try {
        const { data } = await axios({
          url: `${apiEndpoint}/searchproductpro`, method: "POST",
          headers: { "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}` },
          data: { title: searchValue, seller_id: current_sellerid },
        });
        if (data) {
          setproductlist(data?.data); setItemOffset(0);
          if (data?.data?.length < 1) setNoproducts(true);
        }
      } catch { }
    }
  }

  function handleSort(e) {
    if (e.target.value == 0)
      setproductlist([...productlist].sort((a, b) => parseInt(a.selling_price) - parseInt(b.selling_price)));
    else if (e.target.value == 1)
      setproductlist([...productlist].sort((a, b) => parseInt(b.selling_price) - parseInt(a.selling_price)));
    else getproductlist();
  }

  function checkHandler(row) {
    const hasId = selectedBox.some(item => item === row.id);
    setselectedBox(hasId ? selectedBox.filter(item => item !== row.id) : [...selectedBox, row.id]);
  }

  const resetSelectedFields = () =>
    setSelectedFields({
      name: false, mrp: false, selling_price: false, tax_included_price: false,
      quantity: false, description: false, short_description: false, image: false, reference_id: false,
    });

  const showCustomModal = (item) => {
    resetSelectedFields();
    setSelectedProduct(item);
    setformodal(true);
  };

  const handleCheckbox = (e) => {
    const names = e.target.name.split(",");
    const upd = { ...selectedFields };
    names.forEach(name => { upd[name] = e.target.checked; });
    setSelectedFields(upd);
  };

  const showConfirmation = () => {
    AntModal.confirm({
      title: "Are you a seller of this store?",
      okText: "Yes", okType: "primary", cancelText: "No", centered: true,
      okButtonProps: { style: { backgroundColor: "#10b981", borderColor: "#10b981" } },
      onOk: async () => { await handleSubmit(); },
      onCancel: () => { toast.info("Upload cancelled."); },
    });
  };

  /* ── Top-bar dropdown ── */
  const menuOptions = [
    { key: "1", label: <span onClick={() => setTimeout(exportToExcel, 2000)}>Export Data</span> },
    // { key: "2", label: <span onClick={handlebuttonapi}>Sync Shopify Products</span> },
    // {
    //   key: "3",
    //   label: (
    //     <span onClick={() => {
    //       setUpdateType("all");
    //       setSelectedProduct(null);
    //       resetSelectedFields();
    //       setformodal(true);
    //     }}>
    //       Update All Products
    //     </span>
    //   ),
    // },
  ];

  const syncCheckboxRows = [
    { name: "price", label: "Update Price", disabled: false },
    { name: "inventory", label: "Update Quantity", disabled: false },
    { name: "title", label: "Update Title", disabled: false },
    { name: "sku", label: "Update SKU", disabled: true },
    { name: "weight", label: "Update Weight", disabled: true },
  ];

  /* ── Per-row dropdown ── */
  const getRowMenu = (item) => [
    {
      key: "edit",
      label: (
        <Link to={`/createproduct?productId=${item.id}`} style={{ color: "#0f172a", display: "flex", alignItems: "center", gap: "6px" }}>
          Edit
        </Link>
      ),
    },
    // {
    //   key: "export",
    //   label: (
    //     <span style={{ display: "flex", alignItems: "center", gap: "6px" }} onClick={() => {
    //       setUpdateType("single");
    //       showCustomModal(item)
    //     }}>
    //       Update Product
    //     </span>
    //   ),
    // },
    // {
    //   key: "variants",
    //   label: (
    //     <Link
    //       to={`/variantslist?productId=${item?.id}&product_type_id=${item?.product_type_id}&category_id=${item?.category_id}`}
    //       style={{ color: "#0f172a", display: "flex", alignItems: "center", gap: "6px" }}
    //     >
    //       Variants
    //     </Link>
    //   ),
    // },

  ];

  /* ── Image cell helper ── */
  const ImageCell = ({ item }) => {
    const src = item?.has_variations
      ? item?.proImage?.split(",")[0]
      : item?.image?.split(",")[0];
    if (src) {
      return <img src={src} alt="" style={S.productImg} />;
    }
    return <div style={S.noImg}>No Image</div>;
  };

  /* ── Channel badge helper ── */
  const ChannelBadge = ({ item }) => {
    const isShopify = item?.channel_name?.toLowerCase?.() === "shopify" || !item?.channel_name;
    return (
      <span style={S.channelBadge(isShopify)}>
        {isShopify ? <ShopifyIcon /> : (
          <svg width="13" height="13" viewBox="0 0 24 24" fill="#6366f1"><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /></svg>
        )}
        {item?.channel_name || (isShopify ? "Shopify" : "Custom")}
      </span>
    );
  };

  /* ── Toggle switch cell ── */
  const ToggleSwitch = ({ item }) => (
    <label className="switch" style={{ marginBottom: 0 }}>
      <input
        type="checkbox"
        checked={!!itemCheckboxes[item.id]}
        onChange={async () => {
          const isChecked = !itemCheckboxes[item.id];
          setItemCheckboxes(prev => ({ ...prev, [item.id]: isChecked }));
          try {
            await axios({
              url: `${apiEndpoint}/changeproductstatus`, method: "POST",
              headers: {
                "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                "Content-type": "application/json",
              },
              data: { product_id: item.id, isChecked },
            });
          } catch (err) { console.error(err); }
        }}
      />
      <span className="slider round" />
    </label>
  );

  /* ══════════════════════════════════════
     RENDER
  ══════════════════════════════════════ */
  return (
    <ThemeMaker>
      <div className="mcrb-page">

        <div className="mcrb-card">

          {/* ── TOP BAR ── */}
          <div className="mcrb-headbar" style={{ rowGap: "12px" }}>
            <h1 style={{ ...S.pageTitle, flex: "0 0 auto" }}>Product Management</h1>

            {/* Search */}
            <div style={S.searchWrap} >

              <input
                type="search"
                placeholder="Search products…"
                value={searchValue}
                onChange={searchHandler}
                onKeyPress={searchResult}
                style={S.searchInput}
                onFocus={e => (e.target.style.borderColor = "#6366f1")}
                onBlur={e => (e.target.style.borderColor = "#e2e8f0")}
              />
            </div>

            {/* Export */}
            <button
              style={{ ...S.optBtn, color: "#059669", borderColor: "#a7f3d0" }}
              onClick={exportToExcelDatas}
              disabled={isLoading}
            >
              ⬇ {isLoading ? "Exporting…" : "Export"}
            </button>

            {/* Add product */}
            {/* <Link to="/createproduct" style={{ textDecoration: "none" }}>
              <button style={S.addBtn}>+ Add Product</button>
            </Link> */}

            {/* Options dropdown */}
            <Dropdown menu={{ items: menuOptions }} placement="bottomRight">
              <button style={S.optBtn}>
                ⚙ Options ▾
              </button>
            </Dropdown>
          </div>

          {/* Meta */}



          {/* ── TABLE ── */}
          {productisLoading ? (
            <div style={{ display: "flex", justifyContent: "center", padding: "80px 0" }}>
              <Circularprogress />
            </div>
          ) : !noproducts ? (
            <div style={S.tableCard}>
              <div style={S.tableWrap}>
                <table
                  style={{
                    width: "100%",
                    tableLayout: "fixed",
                    borderCollapse: "collapse",

                  }}
                >
                  <colgroup>
                    <col style={{ width: "76px" }} />   {/* Image */}
                    <col style={{ width: "63px" }} />   {/* ID */}
                    <col style={{ width: "230px" }} />    {/* Product Name */}
                    <col style={{ width: "116px" }} />  {/* Selling Price */}
                    <col style={{ width: "116px" }} />  {/* Status */}
                    <col style={{ width: "89px" }} />  {/* Toggle */}
                    <col style={{ width: "80px" }} />  {/* Actions */}
                  </colgroup>

                  <thead>
                    <tr
                      style={{
                        background: "linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%)",
                        borderBottom: "1px solid #5b3fc8",
                      }}
                    >
                      <th style={S.th}>Image</th>
                      <th style={S.th}>ID</th>
                      <th style={S.th}>Product Name</th>
                      <th style={S.th}>Selling Price</th>
                      <th style={S.th}>Status</th>
                      <th style={S.th}>Toggle</th>
                      <th style={S.th}>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentItems.map((item) => (
                      <tr
                        key={item.id}
                        style={{
                          borderBottom: "1px solid #e2e8f0",
                          background: "#fff",
                        }}
                      >
                        <td style={S.td}>
                          <ImageCell item={item} />
                        </td>

                        <td style={S.td}>
                          {item.id}
                        </td>

                        <td
                          style={{
                            ...S.td,
                            fontWeight: 500,
                            color: "#0f172a",
                            lineHeight: "1.5",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                          }}
                        >
                          {item?.name || "—"}
                        </td>

                        <td style={S.td}>
                          ₹{Number(item?.selling_price || item?.price || 0).toLocaleString()}
                        </td>

                        <td style={S.td}>
                          <span style={itemCheckboxes[item.id] ? S.activePill : S.disabledPill}>
                            {itemCheckboxes[item.id] ? "Active" : "Disabled"}
                          </span>
                        </td>

                        <td style={S.td}>
                          <ToggleSwitch item={item} />
                        </td>

                        <td style={S.td}>
                          <Dropdown
                            menu={{ items: getRowMenu(item) }}
                            placement="bottomRight"
                            trigger={["click"]}
                          >
                            <button style={S.moreBtn}>
                              <BsThreeDotsVertical />
                            </button>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>


            </div>
          ) : (
            <div style={{ textAlign: "center", padding: "80px 0", color: "#94a3b8" }}>
              <div style={{ fontSize: "52px", marginBottom: "12px" }}>📦</div>
              <p style={{ fontSize: "16px", fontWeight: 600 }}>No products found</p>
            </div>


          )}

          {formodal && (
            <div className="overlay_modal">
              <div className="custom_modal">
                <div className="modal_body d-flex flex-column ">
                  <h3 className="px-4 text-dark">Select Fields to Update</h3>

                  <label className="checkbox_row">
                    <input
                      type="checkbox"
                      name="name"
                      checked={selectedFields.name}
                      onChange={handleCheckbox}
                    />

                    <span className="text-dark"> Name</span>
                  </label>
                  <label className="checkbox_row">
                    <input
                      type="checkbox"
                      name="quantity"
                      checked={selectedFields.quantity}
                      onChange={handleCheckbox}
                    />

                    <span className="text-dark"> Quantity</span>
                  </label>



                  <label className="checkbox_row">
                    <input
                      type="checkbox"
                      name="mrp"
                      checked={selectedFields.mrp}
                      onChange={handleCheckbox}
                    />
                    <span className="text-dark">MRP</span>
                  </label>

                  <label className="checkbox_row">
                    <input
                      type="checkbox"
                      name="selling_price,tax_included_price"
                      checked={
                        selectedFields.selling_price &&
                        selectedFields.tax_included_price
                      }
                      onChange={handleCheckbox}
                    />
                    <span className="text-dark">Selling Price</span>
                  </label>
                  <label className="checkbox_row">
                    <input
                      type="checkbox"
                      name="description"
                      checked={selectedFields.description}
                      onChange={handleCheckbox}
                    />

                    <span className="text-dark"> Description</span>
                  </label>
                  <label className="checkbox_row">
                    <input
                      type="checkbox"
                      name="short_description"
                      checked={selectedFields.short_description}
                      onChange={handleCheckbox}   // 👈 MUST be added
                    />
                    <span className="text-dark">Short Description</span>
                  </label>

                  <label className="checkbox_row">
                    <input
                      type="checkbox"
                      name="image"
                      checked={selectedFields.image}
                      onChange={handleCheckbox}
                    />

                    <span className="text-dark"> Image</span>
                  </label>



                </div>
                <div>
                  <button className="btn btn-primary d-flex m-auto" onClick={sendUpdate}

                  >Submit</button>
                </div>
                <div>
                  <span className="crossIcon" onClick={() => setformodal(false)}>X</span>
                </div>
              </div>
            </div>
          )}



          {/* ── PAGINATION ── */}
          <div>
            {!productisLoading && pageCount >= 1 && (
              <div style={S.pagination} className="d-flex justify-content-end align-items-center   ">

                <div style={S.pgBtns}>
                  <button
                    style={S.pgBtn(false)}
                    disabled={itemOffset === 0}
                    onClick={() => { window.scrollTo(0, 0); setItemOffset(Math.max(0, itemOffset - PAGE_SIZE)); }}
                  >
                    Previous
                  </button>
                  {Array.from({ length: Math.min(pageCount, 5) }, (_, i) => {
                    const pg = i + 1;
                    const active = Math.floor(itemOffset / PAGE_SIZE) + 1 === pg;
                    return (
                      <button
                        key={pg}
                        style={S.pgBtn(active)}
                        onClick={() => { window.scrollTo(0, 0); setItemOffset((pg - 1) * PAGE_SIZE); }}
                      >
                        {pg}
                      </button>
                    );
                  })}
                  <button
                    style={S.pgBtn(false)}
                    disabled={itemOffset >= (pageCount - 1) * PAGE_SIZE}
                    onClick={() => { window.scrollTo(0, 0); setItemOffset(Math.min((pageCount - 1) * PAGE_SIZE, itemOffset + PAGE_SIZE)); }}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* ════════ SYNC MODAL ════════ */}
          <Modal open={open} onClose={handleSyncModalClose}>
            <Box sx={syncModalSx}>
              <div style={S.modalHeader}>
                <h3 style={S.modalTitle}>Sync Inventory</h3>
                <button style={S.modalCloseBtn} onClick={handleSyncModalClose}><CloseIcon style={{ fontSize: "18px" }} /></button>
              </div>
              {syncCheckboxRows.map(row => (
                <label key={row.name} style={S.syncRow(row.disabled)}>
                  <input
                    type="checkbox"
                    name={row.name}
                    checked={syncingData[row.name]}
                    onChange={syncCheckHandler}
                    disabled={row.disabled}
                    style={{ accentColor: "#6366f1", width: "16px", height: "16px" }}
                  />
                  <span style={{ fontWeight: 500, fontSize: "14px", color: "#0f172a" }}>{row.label}</span>
                </label>
              ))}
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                <button style={{ ...S.ghostBtn, fontSize: "13px" }} onClick={Syncapi}>Product Sync</button>
                <div style={{ display: "flex", gap: "10px" }}>
                  <button style={{ ...S.ghostBtn, fontSize: "13px" }} onClick={handleSyncModalClose}>Cancel</button>
                  <button
                    style={{ background: "#6366f1", color: "#fff", border: "none", borderRadius: "8px", padding: "8px 18px", fontSize: "13px", fontWeight: 600, cursor: "pointer" }}
                    onClick={handleAlertOpen}
                  >
                    Sync
                  </button>
                </div>
              </div>
            </Box>
          </Modal>

          {/* ════════ SYNC CONFIRM DIALOG ════════ */}
          <Dialog open={Alertopen} TransitionComponent={Transition} keepMounted onClose={handleAlertClose}>
            <DialogTitle style={{ fontWeight: 700, color: "#0f172a" }}>Confirm sync?</DialogTitle>
            <DialogContent>
              <DialogContentText>
                The selected parameters will be updated for all matching products. This cannot be undone.
              </DialogContentText>
            </DialogContent>
            <DialogActions style={{ padding: "12px 20px", gap: "8px" }}>
              <Button onClick={handleAlertClose} style={{ color: "#475569" }}>Cancel</Button>
              <button
                style={{ background: "#ef4444", color: "#fff", border: "none", borderRadius: "8px", padding: "8px 18px", fontSize: "13px", fontWeight: 600, cursor: "pointer" }}
                onClick={syncPriceHandler}
              >
                {syncing ? "Syncing…" : "Confirm"}
              </button>
            </DialogActions>
          </Dialog>

          {/* ════════ DELETE MODAL ════════ */}
          <Modal open={ConfirmDeleteModalOpen} onClose={handleShipementModalClose}>
            <Box sx={deleteModalSx}>
              <div style={S.modalHeader}>
                <h3 style={S.modalTitle}>Delete Product</h3>
                <button style={S.modalCloseBtn} onClick={handleShipementModalClose}><CloseIcon style={{ fontSize: "18px" }} /></button>
              </div>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px", padding: "20px 0" }}>
                <div style={{ background: "#fee2e2", borderRadius: "50%", width: "68px", height: "68px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <ReportProblemRoundedIcon style={{ color: "#ef4444", fontSize: "34px" }} />
                </div>
                <div style={{ textAlign: "center" }}>
                  <p style={{ fontWeight: 700, color: "#0f172a", margin: 0, fontSize: "15px" }}>
                    Products once deleted cannot be restored.
                  </p>
                  <p style={{ color: "#475569", margin: "6px 0 0", fontSize: "14px" }}>Are you sure you want to proceed?</p>
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                <button style={{ ...S.ghostBtn, fontSize: "13px" }} onClick={handleShipementModalClose}>Cancel</button>
                {selectedBox.length > 0 ? (
                  <button style={{ ...S.deleteBtn, fontSize: "13px", padding: "8px 16px" }} onClick={bulkdeleteHandler}>
                    Delete {selectedBox.length} products
                  </button>
                ) : (
                  <button style={{ ...S.deleteBtn, fontSize: "13px", padding: "8px 16px" }} onClick={() => deleteProductHandler(productToDelete)}>
                    Delete product
                  </button>
                )}
              </div>
            </Box>
          </Modal>

          {/* ════════ QR MODAL ════════ */}
          <Modal open={QRModalOpen.openstatus} onClose={handleQRModalClose}>
            <Box sx={qrModalSx}>
              <div style={S.modalHeader}>
                <h3 style={S.modalTitle}>Product QR Code</h3>
                <button style={S.modalCloseBtn} onClick={() => setQRModalOpen({ ...QRModalOpen, openstatus: false, isLoading: false })}>
                  <CloseIcon style={{ fontSize: "18px" }} />
                </button>
              </div>
              {QRModalOpen.isLoading === false ? (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
                  <div ref={qrRef} style={{ padding: "16px", background: "#fff", borderRadius: "12px", border: "1.5px solid #e2e8f0" }}>
                    <QRCode style={{ height: "auto", maxWidth: "100%", width: "200px" }} value={QRModalOpen.value} />
                  </div>
                  <p style={{ color: "#475569", fontSize: "13px", margin: 0 }}>Scan QR to view store</p>
                  <button
                    style={{ background: "#6366f1", color: "#fff", border: "none", borderRadius: "8px", padding: "8px 18px", fontSize: "13px", fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" }}
                    onClick={handleDownload}
                  >
                    <DownloadForOfflineRoundedIcon style={{ fontSize: "18px" }} />
                    Download QR
                  </button>
                </div>
              ) : (
                <div style={{ padding: "48px 0", textAlign: "center", color: "#94a3b8" }}>
                  Loading QR code…
                </div>
              )}
            </Box>
          </Modal>

          {/* ════════ FILE UPLOAD MODAL ════════ */}
          <AntModal
            open={modalvisible}
            onCancel={() => setModalvisible(false)}
            width={340}
            mask={false}
            footer={null}
            style={{ borderRadius: "16px" }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: "18px", padding: "8px 0" }}>
              <h4 style={{ margin: 0, fontWeight: 700, color: "#0f172a", fontSize: "16px" }}>Upload CSV File</h4>
              <div style={{ border: "2px dashed #e2e8f0", borderRadius: "12px", padding: "20px", textAlign: "center", background: "#f8fafc" }}>
                <input
                  type="file"
                  accept=".csv"
                  ref={fileInputRef}
                  onChange={e => setSelectedFile(e.target.files[0])}
                  style={{ fontSize: "14px" }}
                />
                {selectedFile && (
                  <p style={{ margin: "10px 0 0", fontSize: "12px", color: "#10b981", fontWeight: 600 }}>
                    ✓ {selectedFile.name}
                  </p>
                )}
              </div>
              <button
                style={{
                  background: selectedFile ? "#6366f1" : "#e2e8f0",
                  color: selectedFile ? "#fff" : "#94a3b8",
                  border: "none", borderRadius: "8px", padding: "10px", fontSize: "14px",
                  fontWeight: 600, cursor: selectedFile ? "pointer" : "not-allowed", width: "100%",
                }}
                onClick={showConfirmation}
                disabled={!selectedFile}
              >
                Submit
              </button>
            </div>
          </AntModal>

        </div>
      </div>
    </ThemeMaker>
  );
};

export default Instorecatalog;